import {DialogActions, DialogContent, FormattedDialogTitle, LoadingContent} from "@dvrt/graphql-widgets";
import {useDocumentsQuery} from "./queries.generated";
import {FormattedMessage, defineMessage} from "react-intl";
import {Button, IconButton, Theme} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import mime from "mime";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getIconFromMIME} from "@/components/documents/tools";
import {useLocale} from "@/context/TranslationProvider";

type ContentProps = {
    close: () => void;
};

const useStyles = makeStyles()((theme: Theme) => ({
    row: {},
    table: {
        borderSpacing: 0,
        "& td": {
            padding: "0.4em 0.6em",
            transition: "background-color 0.5s",
        },
        "& tr:hover td": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    description: {
        fontStyle: "italic",
        opacity: 0.9,
    },
}));

export const DocumentDialogContent = ({close}: ContentProps) => {
    const {data} = useDocumentsQuery({fetchPolicy: "cache-and-network"});
    const {classes} = useStyles();
    const locale = useLocale();

    if (!data) return <LoadingContent title={defineMessage({id: "documents.title", defaultMessage: "Documents"})} />;

    return (
        <>
            <FormattedDialogTitle title={defineMessage({id: "documents.title", defaultMessage: "Documents"})} />
            <DialogContent>
                {data.documents.length === 0 && (
                    <FormattedMessage id="documents.empty" defaultMessage="There are no available documents." />
                )}
                <table className={classes.table}>
                    <tbody>
                        {data.documents
                            .filter((d) => !d.language || d.language === locale)
                            .map((doc, idx) => (
                                <tr key={idx} className={classes.row}>
                                    <td>
                                        <FontAwesomeIcon
                                            size="lg"
                                            style={{marginRight: "0.5em"}}
                                            icon={getIconFromMIME(mime.getType(doc.link))}
                                        />
                                        {doc.title}
                                    </td>
                                    <td className={classes.description}>{doc.description && <>{doc.description}</>}</td>
                                    <td>
                                        <IconButton href={doc.link} color="primary" size="small">
                                            <FontAwesomeIcon icon="download" />
                                        </IconButton>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </DialogContent>
            <DialogActions>
                <Button onClick={close} color="primary" variant="text">
                    <FormattedMessage id="close" defaultMessage="Close" />
                </Button>
            </DialogActions>
        </>
    );
};
